import React from 'react';
import SpinnerWithButton from '../common/SpinnerWithButton';

const CompoundView = ({
  fetching,
  deleting,
  updating,
  executing,
  isFunnelLocation = false,
  cancelButtonDisabled,
  onRequestCancel,
  children,
}) => (
  <div style={{ height: 'calc(100% - 63px)', overflowY: 'auto' }}>
    <SpinnerWithButton
      onClick={onRequestCancel}
      disabled={cancelButtonDisabled}
      executing={fetching || deleting || updating || executing}
      showButton={isFunnelLocation && !(fetching || deleting || updating)}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'stretch',
          height: '100%',
        }}
      >
        {children}
      </div>
    </SpinnerWithButton>
  </div>
);

export default CompoundView;
